import React from "react";
import Slider from "react-slick";
import styles from "../styles/layouts/mvv.module.css";
// import Card from "../layouts/Card";
import CardValores from "../layouts/CardValores";
import execelencia from "../assets/execelencia.png";
import resolucao from "../assets/resolucao.png";
import bandeira from "../assets/logo_encurtada.png";
import merito from "../assets/merito.png";
import dever from "../assets/dever.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Mvv = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* Seção Missão e Visão */}
      <section className={styles.Mvv_section}>
        <h2>MVV</h2>
        <div className={styles.title_underline}></div>
        <p>Confira Nosso MVV</p>
        <div className={styles.row}>
          <div className={styles.Mvv}>
            <h3>Missão</h3>
            <h4>O Que Nos Move</h4>
            <p>
              Desenvolver, por meio da vivência empresarial, profissionais
              capacitados, provendo serviços especializados com excelência.
            </p>
          </div>
          <div className={styles.Mvv}>
            <h3>Visão</h3>
            <h4>Onde Queremos Chegar</h4>
            <p>
              Ser reconhecido como empresa júnior referência no mercado mineiro
              em soluções tecnológicas.
            </p>
          </div>
        </div>
      </section>

      {/* Seção Valores */}
      <section className={styles.cards_section}>
        <div className={styles.title_card}>
          <h1>Nossos Valores</h1>
          <div className={styles.title_card_underline}></div>
        </div>
        <Slider {...sliderSettings} className={styles.slider}>
          <div className={styles.cardWrapper}>
            <CardValores
              img={bandeira}
              title="Orgulho Linked"
              text="Representamos nossa marca com dedicação."
            />
          </div>
          <div className={styles.cardWrapper}>
            <CardValores
              img={resolucao}
              title="Resoluções"
              text="Promovemos inovação e soluções criativas para os problemas dos clientes."
            />
          </div>
          <div className={styles.cardWrapper}>
            <CardValores
              img={dever}
              title=" Dever"
              text="Agimos com ética, responsabilidade e compromisso em todas as interações, internas e externas."
            />
          </div>
          <div className={styles.cardWrapper}>
            <CardValores
              img={execelencia}
              title="Excelência"
              text="Compartilhamos conhecimentos e objetivos para alcançar os melhores resultados."
            />
          </div>
          <div className={styles.cardWrapper}>
            <CardValores
              img={merito}
              title="Mérito"
              text="Acreditamos na valorização do colaborador e do seu esforço."
            />
          </div>
        </Slider>
      </section>
    </>
  );
};

export default Mvv;
